import BaseFormControl from '@material-ui/core/FormControl'

const FormControl = BaseFormControl

export default FormControl
